<template>
    <div class="tab_nav">
        <template v-for="(item,index) in tabs">
            <div
                :class="'tab_item '+ (index == active?'on':'')"
                @click="changeTab"
                :data-index="index"
                :ref="'tab_'+index"
            >
                {{ item }}
            </div>
        </template>
        <div class="line" ref="line" :style="'transform:translateX('+lineLeft+'px)'"></div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../assets/scss/mixin.scss";
.tab_nav {
  display: flex;
  justify-content: space-around;
  position: relative;
  background-color: #fff;

  .tab_item {
    flex: 1;
    text-align: center;
    height: 80px;
    line-height: 80px;
    @include px2px("font-size",30);
    &.on {
      color: $mainBlue;
      @include px2px("font-size",32);
    }
  }
  .line {
    position: absolute;
    width: 64px;
    height: 4px;
    background: $mainBlue;
    left: 0;
    bottom: 0;
    transition: 0.25s;
  }
}
</style>

<script>
export default {
  data() {
    return {
      lineLeft: 0
    };
  },
  props: {
    active: {
      type: Number,
      default: 0
    },
    tabs: {
      type: Array,
      default: function() {
        return ["选项卡1", "选项卡2"];
      }
    }
  },
  methods: {
    changeTab(e) {
      this.$emit("change", e.target.dataset.index);
      this.lineLeft = e.target.offsetLeft + (this.tabW - this.lineW) / 2;
    }
  },
  mounted() {
    this.tabW = this.$refs["tab_" + this.active][0].offsetWidth;
    this.tabL = this.$refs["tab_" + this.active][0].offsetLeft;
    this.lineW = this.$refs.line.offsetWidth;

    this.lineLeft = this.tabL + (this.tabW - this.lineW) / 2;
  }
};
</script>





// WEBPACK FOOTER //
// TabNav.vue?14e80a76